export default {"src":"/_next/static/image/public/images/ic_records_white_small.333d977cf9f2c883057f80f01db5ec2e.svg","height":20,"width":20};